import { useMutation, useQuery } from "@tanstack/react-query";

import {
  addBundle,
  deleteBundle,
  getBundle,
  getBundles,
  updateBundle,
} from "@/api";
import type { Bundle } from "@/types";

export const bundlesQueryKeys = {
  useBundles: () => ["bundles", "getBundles"],
  useBundle: (bundleId?: Bundle["id"]) => ["bundles", "getBundle", bundleId],
};

export const useBundles = () => {
  const useAllBundles = () =>
    useQuery({
      queryFn: () => getBundles(),
      queryKey: bundlesQueryKeys.useBundles(),
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    });

  const useBundle = (bundleId?: Bundle["id"]) =>
    useQuery({
      queryFn: () => getBundle(bundleId),
      queryKey: bundlesQueryKeys.useBundle(bundleId),
      enabled: !!bundleId,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    });

  const useAddBundle = () => useMutation({ mutationFn: addBundle });
  const useUpdateBundle = () => useMutation({ mutationFn: updateBundle });
  const useDeleteBundle = () => useMutation({ mutationFn: deleteBundle });

  return {
    useAllBundles,
    useBundle,
    useAddBundle,
    useUpdateBundle,
    useDeleteBundle,
  };
};
